/**
 * What she says when the scale's reading lands on this phone.
 *
 * The push already said the number on the lock screen; this is the line for
 * the moment he opens the app and the row is suddenly there. So it is not a
 * second announcement of the figure — the figure is in it because every line
 * of hers carries one — it is her taking credit for the plumbing. Toast
 * budget: ≤ 120 chars at maximal context, one line, no exclamation marks.
 */

import type { SassContext } from '@gramas/shared'
import { fmtKg } from '../fmt.js'

type Line = (ctx: SassContext) => string

const kg = (c: SassContext) => `${fmtKg(c.weightKg)} kg`
/** ", riebalai 24,8 %" when the scale saw a body, nothing when it saw socks. */
const fat = (c: SassContext) => (c.bodyFatPct == null ? '' : `, riebalai ${fmtKg(c.bodyFatPct)} %`)

export const SCALE: Readonly<Record<string, ReadonlyArray<Line>>> = {
  'scale_spoke.base': [
    (c) => `Svarstyklės ką tik pranešė: ${kg(c)}${fat(c)}. Aš tik perrašiau.`,
    (c) => `${kg(c)}${fat(c)}. Pačios atsiuntė, tau net pirštu judinti nereikėjo.`,
    (c) => `Kalbėjausi su svarstyklėmis. ${kg(c)}${fat(c)}. Mažakalbės, bet tikslios.`,
    (c) => `Rytinis pranešimas iš vonios: ${kg(c)}${fat(c)}. Užrašyta.`,
    (c) => `${kg(c)}${fat(c)}. Kreivė gavo tašką, kol tu valeisi dantis.`,
    (c) => `Svarstyklės pačios atsiuntė ${kg(c)}${fat(c)}. Vienu įrašu mažiau tau.`,
    (c) => `Naujas taškas: ${kg(c)}${fat(c)}. Vienas rytas — triukšmas, savaitė — signalas.`,
    (c) => `Gavau iš svarstyklių: ${kg(c)}${fat(c)}. Jos su manimi kalba noriau nei tu.`,
    (c) => `${kg(c)}${fat(c)}. Vonioje yra mano informatorė, ir ji ką tik pranešė.`,
  ],
}

/** Once a morning is the cadence; nine lines keep the fortnight clean. */
export const SCALE_META: Readonly<Record<string, number>> = {
  'scale_spoke.base': 7,
}
